import React, { useContext, useEffect, useState, useRef } from "react";
import { Link } from "react-router-dom";
import { CartContext } from "./CartContext";
import axios from "axios";
import { FaBars, FaTimes, FaShoppingCart } from "react-icons/fa";
import "./App.css";
import { getOrFetch } from "./utils/apiCache";

function Header() {
  const { cart } = useContext(CartContext);
  const [categories, setCategories] = useState([]);
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const menuRef = useRef(null);
  
  // Close menu when clicking outside
  useEffect(() => {
    function handleClickOutside(event) {
      if (menuRef.current && !menuRef.current.contains(event.target)) {
        setIsMenuOpen(false);
      }
    }
    
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  useEffect(() => {
    (async () => {
      try {
        const cats = await getOrFetch(
          "categories:parents",
          () =>
            axios
              .get("https://floriakw.com/wp-json/wc/v3/products/categories", {
                auth: {
                  username: "ck_39cd5450af63b97a35e502d9a0a75925866fefab",
                  password: "cs_15701bd9b4392a3b6e5a3d5fa4d326d7acb0a0bf",
                },
              })
              .then((r) => r.data.filter((cat) => cat.parent === 0 && cat.name !== "Uncategorized")),
          { ttlMs: 60 * 60 * 1000 }
        );
        setCategories(cats);
      } catch (err) {
        console.error("Category load error:", err);
      }
    })();
  }, []);

  const closeMenu = () => {
    setIsMenuOpen(false);
  };

  return (
    <>
      <header className="header">
        <div className="container">
          <div className="header-row">
            {/* Logo */}
            <div className="header-logo">
              <Link to="/">
                <img
                  src="https://floriakw.com/wp-content/uploads/2024/09/Untitled-removebg-preview-2-1.png"
                  alt="FLORIA"
                  className="site-logo"
                />
              </Link>
            </div>

            {/* Navigation */}
            <nav className={`header-nav ${isMenuOpen ? 'active' : ''}`} ref={menuRef}>
              <ul className="nav-links">
                {categories.map((cat) => (
                  <li key={cat.id}>
                    <Link 
                      to={`/category/${cat.id}`}
                      onClick={closeMenu}
                    >
                      {cat.name}
                    </Link>
                  </li>
                ))}
              </ul>
            </nav>

            {/* Cart */}
            <div className="header-cart">
              <Link to="/checkout" className="cart-link">
                <FaShoppingCart className="cart-icon" />
                {cart.length > 0 && <span className="cart-count">{cart.length}</span>}
              </Link>
            </div>

            {/* Mobile Menu Button */}
            <button 
              className="hamburger-menu" 
              onClick={() => setIsMenuOpen(!isMenuOpen)}
              aria-label={isMenuOpen ? 'Close menu' : 'Open menu'}
              aria-expanded={isMenuOpen}
            >
              {isMenuOpen ? <FaTimes /> : <FaBars />}
            </button>
          </div>
        </div>
      </header>
      
      {/* Overlay */}
      <div 
        className={`overlay ${isMenuOpen ? 'active' : ''}`} 
        onClick={closeMenu}
        role="button"
        tabIndex="0"
        onKeyDown={(e) => e.key === 'Escape' && closeMenu()}
        aria-label="Close menu"
      />
    </>
  );
  
}

export default Header;
